<!--首页模块一-->
<template>
  <div style="font-family: Alibaba">
    <!--零碳海洋-->
    <div class="boxs_content">
      <div class='index_title'>
        <!--标题-->
        <div>
          <h1>{{ cnNameOne }}</h1>
          <h6>{{ enNameOne }}</h6>
        </div>
        <!--图片-->
        <div class="main_img">
          <el-image
            style="width: 100%"
          :fit='fit'
          v-if='homeOneVo.fullPathUrl != null'
          :src='homeOneVo.fullPathUrl'
        />
        </div>
        <!--内容-->
        <div>
          <h5>
            {{ homeOneVo.title }}
          </h5>
          <div v-html="homeOneVo.briefIntroduction" class="htmlImgSize" style="color: #606266"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  findHomeOne, findEnNameOne
} from '@api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameOne: '',
      cnNameOne: '',
      homeOneVo: {},
      fit: 'cover',
      src: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectHOne()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameOne = data.enName
        that.cnNameOne = data.cnName
      })
    },
    async selectHOne () {
      let that = this
      await findHomeOne().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
        that.homeOneVo = res.data
      })
    },
    handleOneClick () {
      const routeData = this.$router.resolve({
        path: this.homeOneVo.linksVo.href,
        query: { tabId: this.homeOneVo.linksVo.id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
</style>
